module.exports = __webpack_public_path__ + "static/media/logo-desafio.b1531fe6.png";